export default "__VITE_ASSET__8c942c17__"